var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-full flex flex-col items-center hierarchy-select px-4"},[_c('HierarchySelect',{ref:"hierarchySelect",attrs:{"value":_vm.filters.modules,"key-name":"modules","identifier":"module","level":1},on:{"change":function($event){return _vm.$emit('change')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }